@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";

// crisp text rendering 

.commonStyles {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-smooth: always;
}

.h1 {
  font-family: $font-primary;
  font-size: $font-size-h1;
  line-height: $line-height-120-heading;
  @extend .commonStyles;
}

.h2 {
  font-family: $font-primary;
  font-size: $font-size-h2;
  line-height: $line-height-120-heading;
  @extend .commonStyles;
}

.h3 {
  font-family: $font-primary;
  font-size: $font-size-h3;
  line-height: $line-height-120pct;
  @extend .commonStyles;
}

.h4 {
  font-family: $font-primary;
  font-size: $font-size-h4;
  line-height: clamp($line-height-140pct, 1vw + $line-height-130pct, $line-height-130pct);
  @extend .commonStyles;
}

.h5 {
  font-family: $font-primary;
  font-size: $font-size-h5;
  line-height: $line-height-140-heading;
  @extend .commonStyles;
}

.h6 {
  font-family: $font-primary;
  font-size: $font-size-h18;
  line-height: $line-height-140-heading;
  @extend .commonStyles;
}


.size6 {
  font-family: $font-primary;
  font-size: $font-size-h06;
  line-height: $line-height-140-heading;
  @extend .commonStyles;
}

.size7 {
  font-family: $font-primary;
  font-size: $font-size-h07;
  @extend .commonStyles;
}

.size8 {
  font-family: $font-primary;
  font-size: $font-size-h8;
  @extend .commonStyles;
}

.size9 {
  font-family: $font-primary;
  font-size: $font-size-h9;
  @extend .commonStyles;
}

.size10 {
  font-family: $font-primary;
  font-size: $font-size-h10;
  @extend .commonStyles;
}

.size11 {
  font-family: $font-primary;
  font-size: $font-size-h11;
  @extend .commonStyles;
}

.size12 {
  font-family: $font-primary;
  font-size: $font-size-h12;
  @extend .commonStyles;

}

.size13 {
  font-family: $font-primary;
  font-size: $font-size-h13;
  @extend .commonStyles;
}

.size14 {
  font-family: $font-primary;
  font-size: $font-size-h14;
  @extend .commonStyles;
}

.size15 {
  font-family: $font-primary;
  font-size: $font-size-h15;
  @extend .commonStyles;
}

.size16 {
  font-family: $font-primary;
  font-size: $font-size-h16;
  @extend .commonStyles;
}

.size17 {
  font-family: $font-primary;
  font-size: $font-size-h17;
  @extend .commonStyles;
}

.size18 {
  font-family: $font-primary;
  font-size: $font-size-h18;
  @extend .commonStyles;
}

.size19 {
  font-family: $font-primary;
  font-size: $font-size-h19;
  @extend .commonStyles;
}

.size20 {
  font-family: $font-primary;
  font-size: $font-size-h20;
  @extend .commonStyles;
}

.size22 {
  font-family: $font-primary;
  font-size: $font-size-h22;
  @extend .commonStyles;
}


.size24 {
  font-family: $font-primary;
  font-size: $font-size-h24;
  @extend .commonStyles;
}

.size30 {
  font-family: $font-primary;
  font-size: $font-size-h30;
  @extend .commonStyles;
}

.size33 {
  font-family: $font-primary;
  font-size: $font-size-h33;
  @extend .commonStyles;
}

.size36 {
  font-family: $font-primary;
  font-size: $font-size-h36;
  @extend .commonStyles;
}

.size4 {
  font-family: $font-primary;
  font-size: $font-size-h04;
  @extend .commonStyles;
}

.size06 {
  font-family: $font-primary;
  font-size: $font-size-h06;
  @extend .commonStyles;
}

.size07 {
  font-family: $font-primary;
  font-size: $font-size-h07;
  @extend .commonStyles;
}

.body {
  font-family: $font-primary;
  font-size: clamp($fs-20, 0.5vw + $fs-rem-8, $fs-24);
  line-height: $line-height-140-heading;
}



.checkBackground {
  color: $zv-text-muted--Check-Background;
}

.checkGreen {
  color: $zv-success--Check-Green;
}

.fontColor {
  color: $zv-text-secondary--Font-Color;
}

.primaryElectricViolet {
  color: $zv-error--Primary-ElectricViolet;
}

.secondaryNeonLime {
  color: $Secondary-Neon-Lime;
}

.tertiaryAquaBlue {
  color: $Tertiary-AquaBlue;
}

.brandPrimary {
  color: $Brand-Primary;
}

.brandPrimaryLight {
  color: $Brand-Primary-Light;
}

.brandPrimaryDark {
  color: $Brand-Primary-Dark;
}

.brandSecondary {
  color: $Brand-Secondary;
}

.white {
  color: $White;
}

.neutralLightest {
  color: $Neutral-Lightest;
}

.neutralLighter {
  color: $Neutral-Lighter;
}

// Theme Studio text colours (--zv-text-*); fallbacks are the shipped greys.
.neutralLight {
  color: $zv-text-muted--Neutral-Light;
}

.neutral {
  color: $zv-text-secondary--Neutral;
}

.neutralDark {
  color: $zv-text-secondary--Neutral-Dark;
}

.neutralDarker {
  color: $zv-text-primary--Neutral-Darker;
}

.neutralDarkest {
  color: $zv-text-primary--Neutral-Darkest;
}

.hyperlink {
  color: $Hyperlink;
}
.NewBorderRed {
  color: $NewBorder-Red;
}

.hyperlink:hover {
  cursor: pointer;
  color: $zv-text-primary--Neutral-Darkest;
}

.titleText {
  color: $title-text;
}

.bodyText1 {
  color: $body-text-1;
}

.bodyText2 {
  color: $body-text-2;
}

.iconColor {
  color: $zv-text-secondary--icon-color;
}

.mutedText {
  color: $zv-text-secondary--opacity-neutral-darkest-60;
}

.success {
  color: $Success;
}

.error {
  color: $Error;
}

.info {
  color: $Info;
}

.inherit {
  color: inherit;
}
// Theme Studio Headings font for titles (Typography.tsx decides which). Last in
// the file so it outranks the size classes' body font; unthemed it IS that font.
.heading {
  font-family: $zv-font-heading--font-primary;
}
